/**
 * Role-related translations for English language
 * This file contains translations for role names and descriptions
 */
export default {
  roles: {
    merlin: 'Merlin',
    merlinPure: 'Merlin Pure',
    guinevere: 'Guinevere',
    percival: 'Percival',
    tristan: 'Tristan',
    isolde: 'Isolde',
    troublemaker: 'Troublemaker',
    servant: 'Servant',
    goodLancelot: 'Good Lancelot',
    evilLancelot: 'Evil Lancelot',
    lancelots: 'Lancelots',
    mordred: 'Mordred',
    trickster: 'Trickster',
    morgana: 'Morgana',
    oberon: 'Oberon',
    lunatic: 'Lunatic',
    brute: 'Brute',
    minion: 'Minion',
    witch: 'Witch',
    cleric: 'Cleric',
    revealer: 'Revealer',
    role: 'Role',
    unknown: 'Unknown Role',
    mysteryWizard: 'Mystery Wizard',
    unknownLancelot: 'Unknown Lancelot',
    wraith: 'Wraith',
  },
  rolesInfo: {
    roles: 'Roles',
    inGameRoles: 'Roles in game',
    visibleRoles: 'Roles visible to you',
    merlinInfo: 'Knows evil, must remain hidden',
    merlinPureInfo: 'Knows evil and their roles, must remain hidden',
    percivalInfo: 'Knows two wizards (Merlin and Morgana), but does not know which of them is which',
    servantInfo: 'Loyal Servant of Arthur',
    troublemakerInfo: 'Obliged to lie about his loyalty',
    guinevereInfo: 'Knows two Lancelots but does not know their loyalty',
    goodLancelotInfo: 'Good lancelot, can switch role to evil in game',
    evilLancelotInfo: 'Evil lancelot, can switch role to good in game',
    mordredInfo: 'Unknown to Merlin',
    morganaInfo: 'Appears as Merlin for Percival',
    oberonInfo: 'Unknown to Evil',
    minionInfo: 'Minion of Mordred',
    isoldeInfo: 'Lover. Knows Tristan, must remain hidden',
    tristanInfo: 'Lover. Knows Isolde, must remain hidden',
    evilInfo: 'Evil player with an unknown role',
    goodInfo: 'Good player with an unknown role',
    tricksterInfo: 'Lying about his loyalty',
    lunaticInfo: 'Must fail on every mission',
    bruteInfo: 'May fail only first three missions',
    witchInfo: 'Can hide the result of one mission, but this will give a loyalty check to a random player',
    revealerInfo: 'Reveal herself after second failed mission',
    clericInfo: 'Knows loyalty of the leader of the first mission. Must remain hidden',
    unknownInfo: 'Unknown role',
    mysteryWizardInfo: 'One of the two wizards is good (Merlin) or evil (Morgana)',
    unknownLancelotInfo: 'Lancelot, whose loyalty is not known',
    wraithInfo: 'Unknown to Evil and Merlin',
  },
};
